import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthorizationState } from '@modules/authorization/store';

export const selectAuthorizationState = createFeatureSelector<AuthorizationState>('authorization');

const selectCustomer = createSelector(selectAuthorizationState, (s) => s.customer);

export const selectCustomerData = createSelector(selectCustomer, (s) => s.entity);
